import src from "IMAGE";
export default { src, width: 236, height: 38, blurWidth: 0, blurHeight: 0};
